<template>
    <MainContentSearchable title="Listado de compradores permitidos" id="compradores" v-model="filters" :meta="loading ? {} : compradores.meta" @updated="debouncedGetCompradores">
        <template v-slot:header>
            <router-link :to="{ name: 'back.events.sesion.compradores-permitidos.add', params: { evento_id: evento_id, sesion_id: sesion_id } }" class="btn btn-primary mb-3 ml-auto" target="blank">
                Añadir compradores
            </router-link>
        </template>

        <template v-slot:content>
            <ContentOrLoading>
                <div v-if="!loading" :class="['table', { 'expanded': compradores.data.length <= 3 }]">
                    <b-table hover :items="compradores.data" :fields="fields">
                        <template #cell(comprado)="{ item }">
                            <span v-if="item.comprado" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                            <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                        </template>
                        <template #cell(opciones)="{ item, index }">
                            <OpcionesDropdownTableComponent
                                :lastIndex="compradores.data.length > 3 && index >= compradores.data.length - 3"
                                v-bind:options="[
                                    !item.comprado ? { type: 'action', action:() => showModal('borrar-' + item.id), label: 'Borrar'} : {}
                                ]"
                            />
                            <BorrarModalComponent
                                v-if="!item.comprado"
                                :name="'borrar-' + item.id"
                                :title="'Borrar comprador permitido: ' + item.email"
                                confirmButton="¿Está segur@ de borrar el comprador?"
                                @close="() => closeModal('borrar-' + item.id)"
                                @confirm="() => borrar(item.id)"
                            />
                        </template>
                    </b-table>
                </div>
            </ContentOrLoading>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent"

    export default {
        data() {
            return {
                loading: false,
                compradores: null,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: ''
                },
                fields: [
                    { key: "email", label: "Email", class: 'text-center' },
                    { key: "comprado", label: "Comprado", class: 'text-center' },
                    { key: "opciones", label: "Opciones", class: 'text-center' }
                ]
            }
        },
        created() {
            this.getCompradores();
            this.debouncedGetCompradores = _.debounce(this.getCompradores, 500)
        },
        methods: {
            getCompradores() {
                this.loading = true;

                const params = {
                    filters : this.filters,
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesion.compradores-permitidos'), params).then(res => {
                    this.compradores = res.data;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => this.loading = false);
            },
            borrar(comprador_id) {
                this.loading = true;

                let params = {
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    email_id: comprador_id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.sesion.compradores-permitidos.delete'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getCompradores();
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                }).finally(() => this.loading = false);
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            }
        },
        computed: {
            evento_id() {
                return this.$route.params.evento_id;
            },
            sesion_id() {
                return this.$route.params.sesion_id;
            }
        },
        components: {
            MainContentSearchable, OpcionesDropdownTableComponent, BorrarModalComponent
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>